
(function(){
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function syncAnnouncementHeight(){const ann=document.querySelector('.kz-announcement');document.documentElement.style.setProperty('--kz-ann-height',(ann?ann.offsetHeight:0)+'px');}
  window.addEventListener('resize',syncAnnouncementHeight,{passive:true});
  function initHero(){
    document.querySelectorAll('.hero-bg video, #heroVid').forEach(function(v){
      try{
        v.muted=true;
        v.setAttribute('muted','');
        v.setAttribute('playsinline','');
        v.setAttribute('webkit-playsinline','');
        v.setAttribute('preload','auto');
        v.style.transform='none';
        const play=()=>{ if(v.paused && v.play) v.play().catch(()=>{}); };
        play();
        v.addEventListener('canplay', play, {once:true});
        document.addEventListener('visibilitychange', function(){ if(!document.hidden) play(); });
      }catch(e){}
    });
  }
  function initCats(){document.querySelectorAll('.category-shop').forEach(sec=>{const tabs=sec.querySelectorAll('.category-tab');const cards=sec.querySelectorAll('.shop-product-card');function show(cat){cards.forEach(c=>{c.classList.toggle('is-hidden',c.dataset.cat!==cat);});}tabs.forEach(tab=>tab.addEventListener('click',e=>{e.preventDefault();tabs.forEach(t=>{t.classList.remove('active');t.setAttribute('aria-selected','false')});tab.classList.add('active');tab.setAttribute('aria-selected','true');show(tab.dataset.cat)})); if(tabs[0]) show(tabs[0].dataset.cat);});}
  function initDots(){const tstTrack=document.getElementById('tstTrack');const tstDots=document.getElementById('tstDots');if(tstTrack&&tstDots&&!tstDots.childElementCount){const cards=tstTrack.querySelectorAll('.tcard');cards.forEach((_,i)=>{const d=document.createElement('i');if(i===0)d.classList.add('on');d.addEventListener('click',()=>cards[i].scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'}));tstDots.appendChild(d);});const dots=tstDots.querySelectorAll('i');tstTrack.addEventListener('scroll',()=>{const center=tstTrack.scrollLeft+tstTrack.clientWidth/2;let best=0,dist=Infinity;cards.forEach((c,i)=>{const cc=c.offsetLeft+c.clientWidth/2;const d=Math.abs(cc-center);if(d<dist){dist=d;best=i}});dots.forEach((d,i)=>d.classList.toggle('on',i===best));},{passive:true});}}
  function initProduct(){
    const scents=document.querySelectorAll('.scent');
    const picked=document.getElementById('pickedScent');
    const productSize=document.getElementById('productSize');
    const mainImg=document.getElementById('mainImg');
    scents.forEach(s=>{
      if(s.dataset.kzProductSwitcherReady==='true') return;
      s.dataset.kzProductSwitcherReady='true';
      s.addEventListener('click',e=>{
        if((s.getAttribute('href')||'#')==='#') e.preventDefault();
        scents.forEach(x=>x.classList.remove('active'));
        s.classList.add('active');
        if(picked)picked.textContent=s.dataset.name||'';
        if(productSize)productSize.textContent=(s.dataset.volume||'20 ml')+' джобен формат';
        if(mainImg&&s.dataset.img)mainImg.src=s.dataset.img;
      });
    });
    const ingredientPreview=document.getElementById('ingredientPreview');
    document.querySelectorAll('.ing-line').forEach(row=>{
      if(row.dataset.kzIngredientReady==='true') return;
      row.dataset.kzIngredientReady='true';
      const update=()=>{
        document.querySelectorAll('.ing-line').forEach(x=>x.classList.remove('active'));
        row.classList.add('active');
        if(ingredientPreview&&row.dataset.ingImg){
          ingredientPreview.style.opacity='0';
          setTimeout(()=>{
            ingredientPreview.src=row.dataset.ingImg;
            ingredientPreview.alt=row.dataset.ingAlt||'';
            ingredientPreview.style.opacity='1';
          },120);
        }
      };
      row.addEventListener('mouseenter',update);
      row.addEventListener('focusin',update);
      row.addEventListener('click',update);
    });
    const upsell=document.getElementById('upsellItem');
    if(upsell && upsell.dataset.kzUpsellReady!=='true'){
      upsell.dataset.kzUpsellReady='true';
      upsell.addEventListener('click',e=>e.currentTarget.classList.toggle('checked'));
    }
  }

  function initAcc(){
    document.querySelectorAll('.acc').forEach(acc=>{
      if(acc.dataset.kzAccordionReady==='true') return;
      acc.dataset.kzAccordionReady='true';

      const items=Array.from(acc.querySelectorAll('.acc-item'));

      function setBody(body,open,immediate){
        if(!body) return;
        if(immediate){
          body.style.setProperty('transition','none','important');
          body.style.maxHeight=open ? body.scrollHeight+'px' : '0px';
          body.style.opacity=open ? '1' : '0';
          body.offsetHeight;
          body.style.removeProperty('transition');
          return;
        }

        if(open){
          body.style.maxHeight='0px';
          body.style.opacity='0';
          body.offsetHeight;
          window.requestAnimationFrame(()=>{
            body.style.maxHeight=body.scrollHeight+'px';
            body.style.opacity='1';
          });
        }else{
          body.style.maxHeight=body.scrollHeight+'px';
          body.style.opacity='1';
          body.offsetHeight;
          window.requestAnimationFrame(()=>{
            body.style.maxHeight='0px';
            body.style.opacity='0';
          });
        }
      }

      items.forEach((item,idx)=>{
        const head=item.querySelector('.acc-head');
        const body=item.querySelector('.acc-body');
        if(!head||!body)return;

        const initiallyOpen=item.classList.contains('open') || idx===0;
        item.classList.toggle('open',initiallyOpen);
        head.setAttribute('aria-expanded',initiallyOpen?'true':'false');
        setBody(body,initiallyOpen,true);

        head.addEventListener('click',()=>{
          const willOpen=!item.classList.contains('open');

          items.forEach(other=>{
            const otherBody=other.querySelector('.acc-body');
            const otherHead=other.querySelector('.acc-head');
            if(other===item) return;
            if(other.classList.contains('open')){
              other.classList.remove('open');
              if(otherHead) otherHead.setAttribute('aria-expanded','false');
              setBody(otherBody,false,false);
            }
          });

          item.classList.toggle('open',willOpen);
          head.setAttribute('aria-expanded',willOpen?'true':'false');
          setBody(body,willOpen,false);
        });
      });

      window.addEventListener('resize',()=>{
        items.forEach(item=>{
          if(item.classList.contains('open')){
            const body=item.querySelector('.acc-body');
            if(body) body.style.maxHeight=body.scrollHeight+'px';
          }
        });
      },{passive:true});
    });
  }

  function initSmoothFaqDetails(){
    document.querySelectorAll('.kfq__item').forEach(details=>{
      if(details.dataset.kzDetailsReady==='true') return;
      const summary=details.querySelector('summary');
      const answer=details.querySelector('.kfq__answer');
      if(!summary||!answer) return;

      details.dataset.kzDetailsReady='true';
      details.style.overflow='hidden';
      let animation=null;
      let closing=false;
      let expanding=false;

      function finish(open){
        details.style.height='';
        details.style.overflow='hidden';
        animation=null;
        closing=false;
        expanding=false;
        if(!open) details.removeAttribute('open');
        details.dataset.kzAnimating='false';
      }

      function openDetails(){
        const startHeight=details.offsetHeight;
        details.setAttribute('open','');
        const endHeight=summary.offsetHeight+answer.offsetHeight;
        expanding=true;
        details.dataset.kzAnimating='true';
        animation=details.animate(
          {height:[startHeight+'px',endHeight+'px']},
          {duration:360,easing:'cubic-bezier(.22,.61,.36,1)'}
        );
        animation.onfinish=()=>finish(true);
        animation.oncancel=()=>{expanding=false;};
      }

      function closeDetails(){
        const startHeight=details.offsetHeight;
        const endHeight=summary.offsetHeight;
        closing=true;
        details.dataset.kzAnimating='true';
        animation=details.animate(
          {height:[startHeight+'px',endHeight+'px']},
          {duration:320,easing:'cubic-bezier(.22,.61,.36,1)'}
        );
        animation.onfinish=()=>finish(false);
        animation.oncancel=()=>{closing=false;};
      }

      summary.addEventListener('click',event=>{
        event.preventDefault();
        if(closing||!details.open){
          if(animation) animation.cancel();
          openDetails();
        }else if(expanding||details.open){
          if(animation) animation.cancel();
          closeDetails();
        }
      });
    });
  }

  function initMobileMenu(){
    if(document.documentElement.dataset.kzMenuReady==='true') return;
    document.documentElement.dataset.kzMenuReady='true';
    const root=document.documentElement;

    function sync(open){
      root.classList.toggle('kz-menu-open',open);
      if(open) root.classList.remove('kz-cart-open');
      document.querySelectorAll('[data-kz-menu-toggle]').forEach(btn=>btn.setAttribute('aria-expanded',open?'true':'false'));
      document.querySelectorAll('[data-kz-mobile-menu]').forEach(menu=>menu.setAttribute('aria-hidden',open?'false':'true'));
    }

    document.addEventListener('click',event=>{
      const toggle=event.target.closest('[data-kz-menu-toggle]');
      if(toggle){
        event.preventDefault();
        sync(!root.classList.contains('kz-menu-open'));
        return;
      }
      if(event.target.closest('[data-kz-menu-close],[data-kz-menu-link]')){
        sync(false);
      }
    });

    document.addEventListener('keydown',event=>{
      if(event.key==='Escape'&&root.classList.contains('kz-menu-open')) sync(false);
    });

    window.addEventListener('resize',()=>{
      if(window.innerWidth>760) sync(false);
    },{passive:true});
  }

  function initFeaturedMistsTouch(){
    document.querySelectorAll('.fp-track').forEach(track=>{
      if(track.dataset.kzSwipeReady==='true') return;
      track.dataset.kzSwipeReady='true';
      let startX=0,startY=0,dragged=false;

      track.addEventListener('touchstart',event=>{
        const touch=event.touches[0];
        if(!touch) return;
        startX=touch.clientX;
        startY=touch.clientY;
        dragged=false;
      },{passive:true});

      track.addEventListener('touchmove',event=>{
        const touch=event.touches[0];
        if(!touch) return;
        const dx=Math.abs(touch.clientX-startX);
        const dy=Math.abs(touch.clientY-startY);
        if(dx>8&&dx>dy) dragged=true;
      },{passive:true});

      track.addEventListener('click',event=>{
        if(dragged&&event.target.closest('.kz-mist-link')){
          event.preventDefault();
          event.stopPropagation();
        }
        dragged=false;
      },true);
    });
  }

  function initKzVideos(){
    document.querySelectorAll('.ugc-preview-video').forEach(function(v){try{v.muted=true;v.setAttribute('muted','');v.setAttribute('playsinline','');v.setAttribute('preload','metadata');v.addEventListener('loadedmetadata',function(){try{if(v.readyState>0 && v.duration>0){v.currentTime=Math.min(0.05,v.duration/10);}}catch(e){}},{once:true});}catch(e){}});
    document.addEventListener('click',function(e){
      const play=e.target.closest('.ugc-play');
      if(!play) return;
      const box=play.closest('.ugc-video,[data-kz-video-src]');
      if(!box) return;
      e.preventDefault();
      const inner=box.querySelector('video');
      if(inner){
        inner.controls=true;
        inner.muted=false;
        inner.removeAttribute('muted');
        inner.setAttribute('playsinline','');
        inner.setAttribute('preload','auto');
        box.classList.add('is-playing');
        play.style.display='none';
        const mute=box.querySelector('.ugc-mute'); if(mute) mute.style.display='none';
        inner.play && inner.play().catch(()=>{});
        return;
      }
      let src=box.getAttribute('data-kz-video-src')||'';
      if(src.startsWith('//')) src='https:'+src;
      if(!src) return;
      const overlay=document.createElement('div');
      overlay.className='kz-video-modal';
      overlay.innerHTML='<button type=\"button\" aria-label=\"Затвори\">×</button>';
      const v=document.createElement('video');
      v.controls=true; v.autoplay=true; v.playsInline=true; v.setAttribute('playsinline',''); v.setAttribute('preload','auto'); v.src=src;
      overlay.appendChild(v); document.body.appendChild(overlay); v.play && v.play().catch(()=>{});
      overlay.addEventListener('click',ev=>{if(ev.target===overlay||ev.target.tagName==='BUTTON'){overlay.remove();}});
    });
  }
  function initHeaderActions(){
    document.addEventListener('click',function(e){
      const search=e.target.closest('[data-kz-search-open],[drawer-to-open="search-drawer"]');
      if(search){
        if(search.getAttribute && search.getAttribute('is')==='open-drawer') return;
        const nativeBtn=document.querySelector('button[drawer-to-open="search-drawer"]:not([data-kz-search-open]), [data-open-search-popup], .header__search details summary');
        if(nativeBtn && !nativeBtn.matches('a[href="/search"]')){e.preventDefault(); nativeBtn.click(); return;}
        if(!nativeBtn){ e.preventDefault(); window.location.href='/search'; }
      }
    });
  }
  function ready(){syncAnnouncementHeight();initHeaderActions();initMobileMenu();initKzVideos();initHero();initCats();initDots();initProduct();initAcc();initSmoothFaqDetails();initFeaturedMistsTouch();const ugc=document.getElementById('ugcRow');if(ugc&&window.innerWidth>760){ugc.scrollLeft=(ugc.scrollWidth-ugc.clientWidth)/2;}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready(); document.addEventListener('shopify:section:load',ready);
})();
